var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "sw-model-visualization__dimensions\n    sw--position-absolute\n    sw--position-relative--tab\n    sw--width-full\n    sw-grid-flex\n    sw-grid-flex--justify-center\n    sw-grid-flex--justify-flex-start--tab\n    sw--margin-bottom-6--tab"
    },
    [
      _c("div", { staticClass: "sw-grid-flex sw-grid-flex--dir-column" }, [
        _c("div", { staticClass: "sw-grid-flex__cell" }, [
          _c(
            "div",
            {
              staticClass:
                "sw-grid-flex sw-grid-flex--justify-center sw-grid-flex--align-center"
            },
            [
              _c("div", { staticClass: "sw-grid-flex" }, [
                _c("div", { staticClass: "sw--border-transparent-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw-dms--bg-grey-85 sw--border-radius-2 sw--padding-vert-1 sw--padding-hor-2"
                    },
                    [
                      _c("span", { staticClass: "sw-dms--text-light" }, [
                        _vm._v("X")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sw--font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.x))
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sw--border-transparent-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw-dms--bg-grey-85 sw--border-radius-2 sw--padding-vert-1 sw--padding-hor-2"
                    },
                    [
                      _c("span", { staticClass: "sw-dms--text-light" }, [
                        _vm._v("Y")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sw--font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.y))
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "sw--border-transparent-1" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw-dms--bg-grey-85 sw--border-radius-2 sw--padding-vert-1 sw--padding-hor-2"
                    },
                    [
                      _c("span", { staticClass: "sw-dms--text-light" }, [
                        _vm._v("Z")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sw--font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.z))
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "sw-dropdown--plain sw-dropdown__container sw--border-none"
                },
                [
                  _c(
                    "select",
                    {
                      staticClass: "sw-dropdown__select",
                      attrs: {
                        "data-sw-dropdown": "",
                        "data-sw-dropdown-vendor": "selectric",
                        name: "scale"
                      }
                    },
                    [
                      _vm._l(_vm.getScalesForSelect(), function(label, value) {
                        return [
                          _c(
                            "option",
                            {
                              domProps: {
                                selected: value === _vm.scale,
                                value: value
                              }
                            },
                            [_vm._v(_vm._s(label))]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "table",
          {
            staticClass:
              "sw--more-dims\n        sw-dms--color-grey-46\n        sw--width-full\n        sw--margin-top-3\n        sw--margin-top-0--tab\n        sw--display-table--tab"
          },
          [
            _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [_vm._v("Model Volume")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--text-right sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.modelVolume) +
                        " " +
                        _vm._s(_vm.unit)
                    ),
                    _c("sup", [_vm._v("3")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [_vm._v("Machine Space")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--text-right sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.machineSpace) +
                        " " +
                        _vm._s(_vm.unit)
                    ),
                    _c("sup", [_vm._v("3")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [_vm._v("Support Structure")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--text-right sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.supportStructure) +
                        " " +
                        _vm._s(_vm.unit)
                    ),
                    _c("sup", [_vm._v("3")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [_vm._v("Parts Bounds Volume")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--text-right sw--vertical-align__bottom sw--display-table-cell"
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.partsBoundsVolume) + " cm"
                    ),
                    _c("sup", [_vm._v("3")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--vertical-align__bottom sw--display-table-cell sw--padding-top-1"
                  },
                  [_vm._v("Part Count")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "sw--text-right sw--vertical-align__bottom sw--display-table-cell sw--padding-top-1"
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.partCount) + "\n        "
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }